import { render, staticRenderFns } from "./extras.html?vue&type=template&id=f9ece85e&scoped=true&"
import script from "./extras.js?vue&type=script&lang=js&"
export * from "./extras.js?vue&type=script&lang=js&"
import style0 from "./extras.scss?vue&type=style&index=0&id=f9ece85e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ece85e",
  null
  
)

export default component.exports